/* eslint-disable no-nested-ternary */ /* eslint-disable no-promise-executor-return */ /* eslint-disable jsx-a11y/label-has-associated-control */ /* eslint-disable react/prop-types */ /* eslint-disable no-unused-vars */ /* eslint-disable react/no-array-index-key */ import React, {
  useState,
  useRef,
  useContext,
  useEffect,
} from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import Chip from '@material-ui/core/Chip';
import _ from 'lodash';
import { TextField, Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import FlashContext from '../../components/contexts/FlashContext';
import MyButton from '../../components/button/MyButton';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: 10,
    margin: 0,
  },
  chip: {
    margin: 10,
  },
  myTextField: {
    backgroundColor: 'none',
    boxShadow: '2px 2px 2px 1px rgba(0, 0, 0, 0.2)',
    border: 'none',
    color: '#717171',
    fontWeight: 'bold',
    fontFamily: 'Open Sans',
  },
  text: {
    fontFamily: 'Open Sans',
    fontWeight: 'bold',
    color: '#717171',
  },
  input: {
    backgroundColor: '#fff',
    marginTop: 0,
  },
  dateSelect: {
    minWidth: 150,
    marginLeft: 5,
  },
}));

function Filter({
  chipData,
  setChipData,
  find,
  setPage,
  setOpenDialog,
  monthOptions,
  month,
  setMonth,
  yearOptions,
  year,
  setYear,
}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { notifyError } = useContext(FlashContext);

  const searchRef = useRef(null);
  const [searchType, setSearchType] = useState();
  const [selectedStatus, setSelectedStatus] = useState();

  const [options, setOptions] = useState([
    {
      label: t('receivables.filter.options.clientName'),
      value: 'clientName',
    },
    {
      label: t('receivables.filter.options.clientDoc'),
      value: 'clientDoc',
    },
    {
      label: t('receivables.filter.options.costCenter'),
      value: 'costCenter',
    },
    {
      label: t('receivables.filter.options.order'),
      value: 'order',
    },
    {
      label: t('receivables.filter.options.description'),
      value: 'description',
    },
    {
      label: t('receivables.filter.options.status'),
      value: 'status',
    },
  ]);

  const statusOptions = [
    {
      label: t('receivables.filter.statusOptions.pending'),
      value: 'Pendente',
    },
    {
      label: t('receivables.filter.statusOptions.paid'),
      value: 'Pago',
    },
    {
      label: t('receivables.filter.statusOptions.canceled'),
      value: 'Cancelada',
    },
  ];

  const handleDelete = chipToDelete => () => {
    setOptions([
      ...options,
      { label: chipToDelete.by, value: chipToDelete.byType },
    ]);

    const newChips = chipData.filter(chip => chip.key !== chipToDelete.key);

    setChipData(newChips);
    find(newChips);
  };

  const internSearch = () => {
    setPage(0);

    const inputValue = searchRef?.current?.value?.trim();

    if (searchType && inputValue !== '') {
      includeSearch(true);
    } else {
      find();
    }
  };

  const includeSearch = btn => {
    try {
      if (!searchType) {
        notifyError(t('suppliers.filter.errors.addFilter'));
        return;
      }

      const inputValue =
        searchType.value !== 'status'
          ? searchRef?.current?.value?.trim()
          : selectedStatus.value;

      if (!inputValue) {
        notifyError('Insira um valor para o filtro');
        return;
      }

      const newChip = {
        key: new Date().getTime(),
        label: inputValue,
        by: searchType.label,
        byType: searchType.value,
      };

      const newChipList = [...chipData, newChip];
      setChipData(newChipList);

      const newOptions = options.filter(e => e.value !== searchType.value);
      setOptions(newOptions);

      setSearchType(null);
      if (searchRef?.current) {
        searchRef.current.value = '';
      }

      if (btn) {
        find(newChipList);
      }
    } catch (e) {
      console.log(e);
      notifyError('Escolha um Tipo');
    }
  };

  const addChip = () => {
    if (searchType) {
      includeSearch(false);
    } else {
      notifyError(t('suppliers.filter.errors.addFilter'));
    }
  };

  const teclaEnter = e => {
    if (e.key === 'Enter') {
      internSearch();
    }
  };

  return (
    <>
      <Grid
        container
        alignItems="center"
        style={{ marginBottom: 30, marginTop: 15 }}
      >
        <Grid item xs={12} md={2}>
          <MyButton
            onClick={() => setOpenDialog(true)}
            label={t('receivables.filter.buttons.create')}
          />
        </Grid>

        <Grid item xs={12} md={10}>
          <Grid
            container
            spacing={2}
            direction="row"
            alignItems="center"
            justify="flex-end"
          >
            <Grid item>
              <Grid
                container
                direction="column"
                spacing={3}
                alignItems="flex-end"
              >
                <Grid item>
                  <Grid container alignItems="center" justifyContent="flex-end">
                    <h6 className={classes.dateTitle}>
                      {t('receivables.filter.dateTitle')}
                    </h6>
                    <Grid item className={classes.dateSelect}>
                      <Select
                        options={monthOptions}
                        value={monthOptions.find(opt => opt.value === month)}
                        onChange={e => setMonth(e.value)}
                        placeholder="Mês"
                        isSearchable={false}
                      />
                    </Grid>
                    <Grid item className={classes.dateSelect}>
                      <Select
                        options={yearOptions}
                        value={yearOptions.find(opt => opt.value === year)}
                        onChange={e => setYear(e.value)}
                        placeholder="Ano"
                        isSearchable={false}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item>
                  <Grid
                    container
                    spacing={1}
                    alignItems="center"
                    justifyContent="flex-end"
                  >
                    <Grid item>
                      <Select
                        onChange={setSearchType}
                        value={searchType}
                        placeholder={t(
                          'receivables.filter.options.placeholder',
                        )}
                        isSearchable={false}
                        options={options}
                        menuPortalTarget={document.body}
                        styles={{
                          control: base => ({ ...base, minWidth: 200 }),
                        }}
                      />
                    </Grid>
                    <Grid item style={{ display: 'flex' }}>
                      {searchType?.value !== 'status' ? (
                        <TextField
                          onKeyUpCapture={teclaEnter}
                          inputRef={searchRef}
                          variant="outlined"
                          size="small"
                          style={{ minWidth: 250 }}
                          InputProps={{ className: classes.input }}
                        />
                      ) : (
                        <Select
                          onChange={setSelectedStatus}
                          value={selectedStatus}
                          placeholder={t('receivables.filter.options.status')}
                          isSearchable={false}
                          options={statusOptions}
                          menuPortalTarget={document.body}
                          styles={{
                            control: base => ({ ...base, minWidth: 200 }),
                          }}
                        />
                      )}
                      <Button
                        onClick={addChip}
                        variant="contained"
                        style={{ marginLeft: 5 }}
                      >
                        <AddIcon />
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Button
                onClick={internSearch}
                variant="contained"
                color="primary"
              >
                {t('suppliers.filter.buttons.search')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid item className={classes.root}>
          {chipData.map((dt, i) => (
            <li key={i}>
              <Chip
                label={`${dt.by} | ${dt.label}`}
                onDelete={handleDelete(dt)}
                className={classes.chip}
              />
            </li>
          ))}
        </Grid>
      </Grid>
    </>
  );
}

export default Filter;
